import { Box, Button, Dialog, Theme, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import OTPForm from '../../lib/formik/OtpForm'
import { useHistory, useRouteMatch } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { SuccessIcon } from '../../assets/SvgIcons';
import { APPLICATION_TYPE, USER_ROLES } from '../../utils/constant';
import { RootStateType } from '../../redux-store/reducers';
import { GetConsentOtp, GetConsentOtpBody, GetCurrentConsentApplicationBody, VerifyConsentOtp } from '../../redux-store/actions/otpConsent';
import InvOnboardingLayout from '../InvestorOnboarding/InvOnboardingLayout';
import { Applicant, ApplicationProps } from '../../redux-store/types/api-types';

export default function VerifyFormSubmitOTP(): JSX.Element {
    const history = useHistory();
    const { token, message, application, otpRefNo: otpRefNumber, numberOfOTPTries } = history.location.state as unknown as { token: string, message: string, application: ApplicationProps, otpRefNo: string, numberOfOTPTries: number } || {};
    const { uuid = '', applicants = [] } = application || {};
    const { userId = '', id='' } = applicants[0] || {};
    const dispatch = useDispatch();
    const { role = '' } = useSelector((store: RootStateType) => store.auth);
    const theme = useTheme()

    const [otpVerified, setOtpVerified] = useState<boolean>(false);
    const [otpToken, setOtpToken] = useState<string>('');
    const [otpMessage, setOtpMessage] = useState<string>('');
    const [numberOfTries, setNumberOfTries] = useState<number>(0);
    const [otpResponse, setOtpResponse] = useState<Partial<GetConsentOtpBody>>({});
    const [otpRefNo, setOtpRefNo] = useState<string>('');
    const [resendLoading, setResendLoading] = useState<boolean>(false);
    // const [errorMessage, setErrorMessage] = useState<string>('');
    // const [otpSending, setOtpSending] = useState<boolean>(false);
    // const [error, setError] = useState<boolean>(true);

    useEffect(() => {
        setOtpToken(token);
        setOtpMessage(message);
        setOtpRefNo(otpRefNumber);
        setNumberOfTries(numberOfOTPTries);
    }, [otpToken, token, message, otpRefNumber, numberOfOTPTries]);

    const handleSubmit = async (otp: string) => {
        try {
            const res = await dispatch(VerifyConsentOtp({ applicantId: id, otp, verificationToken: otpToken, referenceId: uuid, otpRefNo: otpRefNo })) as unknown as GetCurrentConsentApplicationBody;
            // if (!res) {
            //     setError(true);
            //     return;
            // }
            if (res?.message) {
                setOtpVerified(true);
            }
        } catch (e) {
            console.error((e as Error).message);
        }
    };

    const handleResend = async () => {
        try {
            setResendLoading(true);
            const response = await dispatch(GetConsentOtp({ applicantId: id, referenceId: uuid })) as unknown as GetConsentOtpBody;
            if (!response) {
                return;
            }
            if (response?.phone) {
                setOtpToken(response?.verificationToken ?? '');
                setOtpMessage(`Please enter the OTP sent to ${response?.phone ?? ''} and ${response?.email ?? ''}`);
                setOtpResponse(response);
                setNumberOfTries(response?.numberOfOTPTries ?? 0);
                setOtpRefNo(response?.otpRefNo ?? '');
            }
        } catch (e) {
            console.error((e as Error).message);
        } finally {
            setResendLoading(false);
        }
    }


    return (
        <InvOnboardingLayout>
            <>
                <Box component={'div'} style={{ marginBottom: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 8px' }}>
                    {USER_ROLES.INVESTOR.includes(role) && (
                        <Typography variant='h1' sx={{ color: 'text.primary' }}>
                            {application?.onboardingType?.toLowerCase() === "minor" ?
                                `Minor Investor Onboarding` :
                                ""
                            }
                            {(application?.onboardingType?.toLowerCase() === "normal" &&
                                application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                                `Individual Investor Onboarding` :
                                ""
                            }
                            {(application?.onboardingType?.toLowerCase() === "normal" &&
                                application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                                `Non Individual Investor Onboarding` :
                                ""
                            }
                        </Typography >
                    )}
                    {USER_ROLES.INVESTOR.includes(role) && <Typography sx={{ fontWeight: '500', fontSize: 16, letterSpacing: '0.02px', color: 'text.primary' }}>{`Application ID: ${application?.applicationNumber}`}</Typography>}
                </Box>

                <Box
                    sx={{
                        px: { xs: 2, sm: 4, md: 6 },
                        py: { xs: 3, sm: 4, md: 6 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={(theme: Theme) => ({
                            mt: 3,
                            borderRadius: '20px',
                            backgroundColor: theme.palette.common.white,
                            p: { xs: 3, sm: 4, md: 6 },
                            boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            maxWidth: '670px',
                        })}
                    >
                        {otpVerified ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: { xs: 2, sm: 3 },
                                    // px: { xs: 2, sm: 4 },
                                    textAlign: 'center',
                                }}
                            >
                                <Typography
                                    variant="body_500"
                                    sx={{
                                        mt: 1,
                                        mb: 1,
                                        color: 'success.500',
                                        fontWeight: 600,
                                    }}
                                >
                                    Congratulations!
                                </Typography>

                                <SuccessIcon />

                                <Typography variant="body_500" color="text.secondary">
                                    OTP Verified Successfully
                                </Typography>

                                <Typography
                                    variant="subtitle_400"
                                    sx={(theme: Theme) => ({
                                        lineHeight: '22px',
                                        letterSpacing: '0.02px',
                                        color: theme.palette.text.secondary,
                                        mb: 2,
                                    })}
                                >
                                    Your consent has been successfully verified. Your Relationship Manager (RM) will contact you shortly with further updates.
                                </Typography>

                                <Typography variant="body_600" color="text.primary" mb={2}>
                                    Would you like to complete your Video-KYC?
                                </Typography>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        width: '100%',
                                        gap: 2,
                                    }}
                                >
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        sx={(theme: Theme) => ({
                                            color: theme.palette.primary.light,
                                            borderColor: theme.palette.primary.light,
                                            ...theme.typography.body_500,
                                        })}
                                        onClick={() =>
                                            history.replace(`/investor-onboarding-application-details/${application?.id}`)
                                        }
                                    >
                                        Not Now
                                    </Button>

                                    <Button
                                        fullWidth
                                        variant="contained"
                                        sx={{
                                            ...theme.typography.body_500,
                                        }}
                                        onClick={() => {
                                            alert('Would Call the API to complete the video KYC');
                                        }}
                                    >
                                        Continue
                                    </Button>
                                </Box>
                            </Box>

                        ) : (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
                                <Box sx={{ width: "90%" }}>
                                    <OTPForm
                                        onSubmit={handleSubmit}
                                        onResend={handleResend}
                                        otpMessage={otpMessage ?? ''}
                                        //  warningMessage='Note: You can request up to two SMS OTPs and one Voice OTP per hour.'
                                        warningMessage='Note: You can request up to three SMS OTPs per hour.'
                                        numberOfTries={numberOfTries}
                                    />
                                </Box>
                                <Typography variant="body_400" color={'text.secondary'} textAlign={'center'} mt={1}>
                                    Note: Please dont press the back button or navigate back.
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </>

        </InvOnboardingLayout>

    )
}
